import * as Yup from "yup";

const companyRegisterSchema = Yup.object({
  username: Yup.string()
    .required("INPUT.VALIDATION.USERNAME")
    .min(3, "INPUT.VALIDATION.USERNAME.MIN.CHARACTER")
    .max(20, "INPUT.VALIDATION.USERNAME.MAX.CHARACTER")
    .matches(/^[a-zA-Z0-9_]+$/, "INPUT.VALIDATION.USERNAME.MATCHES.CHARACTER"),
  first_name: Yup.string()
    .required("INPUT.VALIDATION.FIRSTNAME")
    .min(2, "INPUT.VALIDATION.FIRSTNAME.MIN"),

  last_name: Yup.string()
    .required("INPUT.VALIDATION.LASTNAME")
    .min(2, "INPUT.VALIDATION.LASTNAME.MIN"),
  password: Yup.string()
    .required("INPUT.VALIDATION.PASSWORD")
    .min(8, "INPUT.VALIDATION.PASSWORD.MIN.CHARACTER")
    .matches(/(?=.*[0-9!@#$%^&*])/, "INPUT.VALIDATION.PASSWORD.REQUIREMENTS"),
  mobile_number: Yup.string().required("INPUT.VALIDATION.MOBILENUMBER"),
  email: Yup.string()
    .required("INPUT.VALIDATION.EMAIL")
    .email("INPUT.VALIDATION.EMAIL"),
  company_name: Yup.string().required("INPUT.VALIDATION.COMPANY.NAME"),
  business_type: Yup.array().min(1, "INPUT.VALIDATION.COMPANY.BUSINESS.TYPE"),
  intent: Yup.array().min(1, "INPUT.VALIDATION.COMPANY.BUSINESS.INTENT"),
  candidate_msg: Yup.bool().required("INPUT.VALIDATION.COMPANY.CANDIDATE.MSG"),
  address: Yup.object({
    regionId: Yup.string().required("INPUT.VALIDATION.REGION"),
    address_line_1: Yup.string().required(
      "INPUT.VALIDATION.ADDRESS.ADDRESS.LINE1"
    ),
    city: Yup.string().required("INPUT.VALIDATION.ADDRESS.ADDRESS.CITY"),
    postal: Yup.string().required("INPUT.VALIDATION.ADDRESS.ADDRESS.ZIPCODE"),
  }),
  sms_opt_out: Yup.boolean()
    .nullable()
    .oneOf([true, false], "Please select SMS opt out option")
    .required("Please select SMS opt out option"),
});

export default companyRegisterSchema;
